import { render, staticRenderFns } from "./SignupDialog.vue?vue&type=template&id=9f7f06a0&scoped=true"
import script from "./SignupDialog.vue?vue&type=script&lang=js"
export * from "./SignupDialog.vue?vue&type=script&lang=js"
import style0 from "./SignupDialog.vue?vue&type=style&index=0&id=9f7f06a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7f06a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f7f06a0')) {
      api.createRecord('9f7f06a0', component.options)
    } else {
      api.reload('9f7f06a0', component.options)
    }
    module.hot.accept("./SignupDialog.vue?vue&type=template&id=9f7f06a0&scoped=true", function () {
      api.rerender('9f7f06a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SignupDialog.vue"
export default component.exports